<div class="container">
    <div class="row m-5">
      
                <div class="col-md-6 offset-1">
                    <h1 class="form-title text-danger"> <b>Sign up</b> </h1>
                    <form [formGroup]="userForm" >
                        <div class="form-group">
                            <input type="text" name="Name" formControlName="Name" placeholder="Enter Your Name" class="form-control" appNameValidator >
                           
                                <div *ngIf= "userForm.get('Name').invalid" class="text-danger"> 
                                    <!-- <span *ngIf= "userForm.get('firstName').errors.inv">
                                          The first letter must be capital letter 
                                    </span> --> 

                                    <span *ngIf= "userForm.get('Name').errors.lengthError">
                                            The firstname  must be more than 3 letters
                                      </span>
                                </div>
                        </div>

                        
                        <div class="form-group">
                            <input type="text" name="userName"formControlName="userName" placeholder="username" class="form-control">
                        
                                    <div *ngIf = "userForm.get('userName').invalid && userForm.get('userName').touched">
                                        <span *ngIf="userForm.get('userName').errors">
                                                Put in your Username
                                       </span>
                                    </div>
                        </div>

                        <div class="form-group">    
                            <input type="email" name="email" formControlName="email" placeholder="Enter Your Email" class="form-control" appEmailValidator>
                            
                            <div *ngIf= "userForm.get('email').invalid" class="text-danger">
                                <span *ngIf= "userForm.get('email').errors.inv">
                                      Check your Email  
                                </span>
                            
                                <!-- <span *ngIf= "userForm.get('email').errors.lengthError">
                                       Add @yahoo.com or @gmail.com
                                  </span> -->
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <input type="mobile" name="mobile" formControlName="mobile" placeholder="Enter Your Mobile Number" class="form-control">
                        
                            <div *ngIf= "userForm.get('mobile').invalid" class="text-danger">
                                <span *ngIf= "userForm.get('mobile').errors.inv">
                                    Add your country code 
                                </span>
                            
                                <span *ngIf= "userForm.get('mobile').errors.lengthError">
                                    Your Number should be up to 11
                                  </span>
                            </div>     
                        
                        </div>
                        <div class="form-group">
                            <input type="password" name="password" formControlName="password" placeholder="Enter Your Password" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="password" name="confirmpassword"  placeholder="Re-Enter Your Password" class="form-control">
                        </div>
                        <div class="form-group">  
                            <input type="file" (input)="pic()" formControlName="picture" name="pix" class="form-control" placeholder="Upload Your Profile Picture"> 
                         </div> 
                        <br><br>
                     <div class="form-group form-button">
                        <input type="submit" [disabled]="userForm.invalid" (click)="submitForm()" class="form-submit btn btn" style="background-color:#7F0026; color:white" value="Register" >
                    </div>
                    </form>
                </div>
                <div class="col-md-3 offset-1">
                    <figure><img src="assets/logo.png" alt="sing up image" style="border-radius: 300px;margin-top: 4em"></figure>
                    <a routerLink="../login" class="signup-image-link" style="color: white; font-size:1.5em; text-decoration:none">I am  already a member</a>
                </div>
        </div>
   
</div>